import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type {
    IsoAndUnixTimestamp} from "../../date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "../../date-time/iso-and-unix";
import { idZodSchema } from "../../id";
import type { PrinterId} from "../printer-id";
import { printerIdZodSchema } from "../printer-id";

type PrinterActivateCommand = {
    readonly _id: string;
    readonly _type: "PRINTER_ACTIVATE_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly printerId: PrinterId;
};

type FactoryParams = Except<
    PrinterActivateCommand,
    "_id" | "_type" | "_createdAt"
>;
const printerActivateCommandFactory = (params: FactoryParams) => {
    const command: PrinterActivateCommand = {
        ...params,
        _id: generateId({ prefix: "printer_activate_command__" }),
        _type: "PRINTER_ACTIVATE_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

const printerActivateCommandIdZodSchema = idZodSchema.regex(
    /^printer_activate_command__.*$/,
);
const printerActivateCommandZodSchema: z.ZodSchema<PrinterActivateCommand> =
    z.object({
        _id: printerActivateCommandIdZodSchema,
        _type: z.literal("PRINTER_ACTIVATE_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        printerId: printerIdZodSchema,
    });

export {
    printerActivateCommandFactory,
    printerActivateCommandIdZodSchema,
    printerActivateCommandZodSchema,
};
export type { PrinterActivateCommand };
